import { CoreUiException } from "./core-ui-exception";

/**
 * Exception used when there router state is invalid
 */
export class RouterStateException extends CoreUiException {
    constructor(
        message: string,
        error?: any
    ) {
        super("RouterStateException", message, error);
    }
}
